// extracted by mini-css-extract-plugin
export default {"subHeading":"FieldReactSelect_subHeading__80bvI"};